import { QUESTIONS_KEY } from './utils';

export const PLUS_NAME_FOR_OLD_QUOTE = 'OldQuote';
export const GOOGLE_CAPTCHA_KEY = "6Lf-UWAoAAAAALI4XslJ74ZK0YV1_mK3Zi90emjJ";
export const DATA_QUESTION_MOVING_NEXT: Record<string, any> = {
  primaryCarePhysicianAddress: 'personalInterests',
  contactTimeDate: 'primaryCarePhysicianName',
  readyToScheduleHomeAppt: [
    {
      nextKey: 'contactTimeDate',
      condition: {
        readyToScheduleHomeAppt: '1',
      },
    },
    {
      nextKey: 'anyAdditionalInfo',
      condition: {
        readyToScheduleHomeAppt: '2',
      },
    },
  ],
  currentlyInHospitalOrRehab: [
    {
      nextKey: 'dischargeDate',
      condition: {
        currentlyInHospitalOrRehab: '1',
      },
    },
    {
      nextKey: 'serviceStartDate',
      condition: {
        currentlyInHospitalOrRehab: '2',
      },
    },
  ],
  whosInquiringFor: 'propertyType',
  paymentCategory: [
    {
      nextKey: 'propertyType',
      condition: {
        patientCallingFor: '2',
      },
    },
    {
      nextKey: 'propertyType',
      condition: {
        isStaff: '3',
      },
    },
  ],
  relationship: 'recipientName',
  decisionMaker: 'recipientName',
  decisionMakerOther: 'recipientName',
  callerEmail: 'recipientName',
  fillerEmail: 'recipientName',
  patientCallingFor: [
    {
      nextKey: 'recipientName',
      condition: {
        patientCallingFor: '1',
      },
    },
    {
      nextKey: 'callerName',
      condition: {
        patientCallingFor: '2',
      },
    },
  ],
  isStaff: [
    {
      nextKey: 'staffMemberName',
      condition: {
        isStaff: '1',
      },
    },
    {
      nextKey: 'recipientName',
      condition: {
        isStaff: '2',
      },
    },
    {
      nextKey: 'fillerName',
      condition: {
        isStaff: '3',
      },
    },
  ],
  recipientEmail: 'currentlyInHospitalOrRehab',
  hospitalName: 'serviceStartDate',
  serviceStartDate: 'source',
  transfers: [
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '3',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '4',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '5',
      },
    },
    {
      nextKey: 'toileting',
      condition: {

      },
    },
  ],
  transfersOther: [
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '3',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '4',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '5',
      },
    },
    {
      nextKey: 'toileting',
      condition: {

      },
    },
  ],
  transfersUncertain: [
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '3',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '4',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '5',
      },
    },
    {
      nextKey: 'toileting',
      condition: {

      },
    },
  ],
  recipientWeight: [
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '3',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '4',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '5',
      },
    },
    {
      nextKey: 'toileting',
      condition: {

      },
    },
  ],
  toileting: [{
    nextKey: 'incontinent',
    condition: {
      toileting: '4',
    },
  },
  {
    nextKey: 'bathing',
    condition: {

    },
  },

  ],
  toiletingOther: "bathing",
  toiletingUncertain: "bathing",
};

export const DATA_QUESTION_LAST: Record<string, any> = {
  'inquiry-intake': ['generalConcernsAll'],
  'needs-required': ['nutrition'],
  'safety': ['contactTimeDatedate', 'contactTimeDatetime', 'anyAdditionalInfo', 'contactTimeDate'],
  'additional-notes': ['anyAdditionalPerson'],
  'minimal-potential-client-intake': ['daysRequiredService'],
  'potential-client-intake': ["generalConcernsAll"],
  'needs-required-2': ['nutrition'],
  'safety-2': ['contactTimeDatedate', 'contactTimeDatetime', 'anyAdditionalInfo', 'contactTimeDate'],
  'additional-notes-2': ['additionalNotes'],

};

export const DATA_QUESTION_MOVING_PREV: Record<string, any> = {
  '1st_recipient': {
    primaryCarePhysicianName: [
      {
        backKey: 'readyToScheduleHomeAppt',
        condition: {
          readyToScheduleHomeAppt: '1',
        },
      },
      {
        backKey: 'readyToScheduleHomeAppt',
        condition: {
          readyToScheduleHomeAppt: '2',
        },
      },
    ],
    contactTimeDate: 'servicesProvided',
    anyAdditionalInfo: 'servicesProvided',
    readyToScheduleHomeAppt: 'servicesProvided',
    patientCallingFor:'isStaff',
    recipientName: [
      {
        backKey: 'isStaff',
        condition: {
          patientCallingFor: '1',
        },
      },
      {
        backKey: 'patientCallingFor',
        condition: {
          patientCallingFor: '2',
        },
      },
      {
        backKey: 'reassessmentQuote',
        condition: {
          isStaff: '2',
        },
      },
      {
        backKey: 'isStaff',
        condition: {
          isStaff: '3',
        },
      },
    ],
    relationship: [
      {
        backKey: 'anyAdditionalPerson',
        condition: {
          anyAdditionalPerson: '1',
        },
      },
      {
        backKey: 'anyAdditionalPerson',
        condition: {
          anyAdditionalPerson: '0',
        },
      },
      // {
      //   backKey: 'fillerEmail',
      //   condition: {
      //     isStaff: '3',
      //   },
      // },
    ],
    decisionMaker:
      [
        {
          backKey: 'anyAdditionalPerson',
          condition: {
            anyAdditionalPerson: '1',
          },
        },
        {
          backKey: 'anyAdditionalPerson',
          condition: {
            anyAdditionalPerson: '0',
          },
        },
        // {
        //   backKey: 'fillerEmail',
        //   condition: {
        //     isStaff: '3',
        //   },
        // },
      ],
    transferAssist: "assistiveDevices",
    propertyType: [
      {
        backKey: 'paymentCategory',
        condition: {
          patientCallingFor: '2',
        },
      }, // or
      {
        backKey: 'paymentCategory',
        condition: {
          isStaff: '3',
        },
      },
    ],
    fillerName: 'reassessmentQuote',
    staffMemberName: 'reassessmentQuote',
    reassessmentQuote: 'languagePreference',
    currentlyInHospitalOrRehab: [
      {
        backKey: 'isStaff',
        condition: {
          isStaff: '2',
        },
      },
      {
        backKey: 'patientCallingFor',
        condition: {
          patientCallingFor: '1',
        },
      },
      {
        backKey: 'recipientName',
        condition: {
          patientCallingFor: '2',
        },
      },
    ],
    callerName: 'isStaff',
    serviceStartDate: 'currentlyInHospitalOrRehab',
    dischargeDate: [
      {
        backKey: 'isStaff',
        condition: {
          isStaff: '2',
        },
      },
      {
        backKey: 'patientCallingFor',
        condition: {
          patientCallingFor: '1',
        },
      },
      {
        backKey: 'recipientName',
        condition: {
          patientCallingFor: '2',
        },
      },
      {
        backKey: 'recipientName',
        condition: {
          isStaff: '3',
        },
      },
    ],
    source: 'serviceStartDate',
    incontinent: "transfers",
    toileting: "transfers",
    bathing: "toileting",
  },
  full_care_2nd_recipient: {
    dischargeDate: 'recipientName',
    serviceStartDate: 'currentlyInHospitalOrRehab',
    primaryCarePhysicianName: [
      {
        backKey: 'readyToScheduleHomeAppt',
        condition: {
          readyToScheduleHomeAppt: '1',
        },
      },
      {
        backKey: 'readyToScheduleHomeAppt',
        condition: {
          readyToScheduleHomeAppt: '2',
        },
      },
    ],
    contactTimeDate: 'servicesProvided',
    anyAdditionalInfo: 'servicesProvided',
    readyToScheduleHomeAppt: 'servicesProvided',
    transferAssist: "assistiveDevices",
    incontinent: "transfers",
    toileting: "transfers",
    bathing: "toileting",


  },
};

export const DATA_QUESTION_REMOVE: Record<string, any> = {
  isStaff: {
    '1': ['fillerName',
      'fillerPhoneNumber',
      'fillerEmail',
    ],
    '2': [
      'staffMemberName',
      'patientCallingFor',
      'callerName',
      'callerPhoneNumber',
      'callerEmail',
      'fillerName',
      'fillerPhoneNumber',
      'fillerEmail',
      'relationship',
      'decisionMaker',

     // QUESTIONS_KEY.CREATE_A_NEW_QUOTE,
     // `${QUESTIONS_KEY.CREATE_A_NEW_QUOTE}${PLUS_NAME_FOR_OLD_QUOTE}`,
    ],
    '3': [
      'staffMemberName',
      'patientCallingFor',
      'callerName',
      'callerPhoneNumber',
      'callerEmail',
     // QUESTIONS_KEY.CREATE_A_NEW_QUOTE,
      //`${QUESTIONS_KEY.CREATE_A_NEW_QUOTE}${PLUS_NAME_FOR_OLD_QUOTE}`,
    ],
  },
  patientCallingFor: {
    '1': ['callerName', 'callerPhoneNumber', 'callerEmail', 'relationship', 'decisionMaker'],
  },
  currentlyInHospitalOrRehab: {
    '2': ['dischargeDate', 'hospitalName'],
  },
  readyToScheduleHomeAppt: {
    '1': ['anyAdditionalInfo'],
    '2': ['contactTimeDate'],
  },
  gatedCommunity: {
    '2': ['gatedCommunityOther'],
  },
  transfers: {
    "1": ["transferAssist"],
    "2": ["transferAssist"],
    "@UN": ["transferAssist"],
    "OT": ["transferAssist"]
  },
  toileting: {
    "1": ["incontinent"],
    "2": ["incontinent"],
    "3": ["incontinent"],
    "5": ["incontinent"],
    "@UN": ["incontinent"],
    "OT": ["incontinent"]
  },

};

export const DATA_QUESTION_HIDE_PROPERTY = [
  'full_care_2nd_recipient/potential-client-intake/relationship',
  'full_care_2nd_recipient/potential-client-intake/recipientName',
  'full_care_2nd_recipient/potential-client-intake/recipientDob',
  'full_care_2nd_recipient/potential-client-intake/recipientPhoneNumber',
  'full_care_2nd_recipient/potential-client-intake/recipientEmail',
  'full_care_2nd_recipient/potential-client-intake/companionSitterAll',
  'full_care_2nd_recipient/potential-client-intake/daysRequiredService',
  'full_care_2nd_recipient/potential-client-intake/hoursNeeded',
  'full_care_2nd_recipient/potential-client-intake/serviceStartDate',
];

export const KEYBOARD_TYPE = {
  text: 'text',
  email: 'emailAddress',
  address: 'streetAddress',
  textArea: 'multiline',
};


export const ANSWER_KEY_DEFAULT = {
  anyAdditionalPerson: `1st_recipient/additional-notes/${QUESTIONS_KEY.ADDITIONAL_PERSON}`,
  contagions: `1st_recipient/needs-required/${QUESTIONS_KEY.CONTAGIONS}`,
  languagePreference: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.SELECT_LANGUAGE}`,
  staffMemberName: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.STAFF_MEMBER_NAME}`,
  isStaff: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.IS_STAFF}`,
  reassessmentQuote: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.CREATE_A_NEW_QUOTE}`,
  reassessmentQuoteOldQuote: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.CREATE_A_NEW_QUOTE}${PLUS_NAME_FOR_OLD_QUOTE}`,
  relationship: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.RELATIONSHIP}`,
  contactTimeDate: `1st_recipient/safety/${QUESTIONS_KEY.CONTACT_TIME_DATE}`,
  contactTimeDatetime: `1st_recipient/safety/${QUESTIONS_KEY.CONTACT_TIME_DATE_TIME}`,
  contactTimeDatedate: `1st_recipient/safety/${QUESTIONS_KEY.CONTACT_TIME_DATE_DATE}`,
  contactTimeDate2nd: `full_care_2nd_recipient/safety-2/${QUESTIONS_KEY.CONTACT_TIME_DATE}`,
  contactTimeDatetime2nd: `full_care_2nd_recipient/safety-2/${QUESTIONS_KEY.CONTACT_TIME_DATE_TIME}`,
  contactTimeDatedate2nd: `full_care_2nd_recipient/safety-2/${QUESTIONS_KEY.CONTACT_TIME_DATE_DATE}`,
  readyToScheduleHomeAppt: `full_care_2nd_recipient/safety-2/${QUESTIONS_KEY.READY_TO_SCHEDULE_HOME_APPT}`,
  petCare: `1st_recipient/needs-required/${QUESTIONS_KEY.PET_CARE}`,
  recipientName: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.RECIPIENT_NAME}`,
  recipientPhone: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.RECIPIENT_PHONE}`,
  recipientEmail: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.RECIPIENT_EMAIL}`,
  fillerEmail: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.FILLER_EMAIL}`,
  fillerName: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.FILLER_NAME}`,
  fillerPhoneNumber: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.FILLER_PHONE_NUMBER}`,
  contactTimeDateemail: `1st_recipient/safety/${QUESTIONS_KEY.CONTACT_TIME_DATE_EMAIL}`,
  contactTimeDatename: `1st_recipient/safety/${QUESTIONS_KEY.CONTACT_TIME_DATE_NAME}`,
  contactTimeDatephone: `1st_recipient/safety/${QUESTIONS_KEY.CONTACT_TIME_DATE_PHONE}`,
  propertyType: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.PROPERTY_TYPE}`,
  patientCallingFor: `1st_recipient/inquiry-intake/${QUESTIONS_KEY.PATIENT_CALLING_FOR}`,


};
export const REASSESSMENT_DISABLE_ANSWER_KEY_DATA = [
  QUESTIONS_KEY.CALLER_NAME,
  QUESTIONS_KEY.CALLER_EMAIL,
  QUESTIONS_KEY.CALLER_PHONE_NUMBER,
  QUESTIONS_KEY.RELATIONSHIP,
  QUESTIONS_KEY.DECISION_MAKER,
];
export const INQUIRY_INTAKE = '1st_recipient/inquiry-intake/'


export const DATA_QUESTION_REQUIRED = {
  '1st_recipient/inquiry-intake/recipientPhoneNumber': {
    key: '1st_recipient/inquiry-intake/patientCallingFor',
    '1': true,
    '2': false,
  },
  '1st_recipient/inquiry-intake/recipientEmail': {
    key: '1st_recipient/inquiry-intake/patientCallingFor',
    '1': true,
    '2': false,
  },
};

export const HOUR_RATE_WEIGHTS = {
  0: 1,
  1: 1,
  2: 1.5,
  3: 2,
};

export const QUOTE_STATUS = {
  draft: 'draft',
  submitted: 'submitted',
  completed: 'completed',
  invalid: 'invalid',
};
export const GENERATION_V3 = 'generation_3.0';
export const CATEGORY_KEYS = {
  "generation_1.0": {
  review: 'review',
  inquiry_intake: 'inquiry-intake',
  additional_notes:'additional-notes',
  safety2: "safety-2",
  potentialClientIntake:'potential-client-intake',
  minimalPotentialClientIntake:'minimal-potential-client-intake',
  additionalNotes2:'additional-notes-2'
  },
  "generation_3.0": {
    review: 'review-v3',
    inquiry_intake: 'intake-context',
    functional_needs: 'functional-needs',
    safety_clinical_complexity: "safety-clinical-complexity",
    support_care_team: 'support-care-team',
    intake_context_2: 'intake-context-2',
    functional_needs_2: 'functional-needs-2',
    safety_clinical_complexity_2: 'safety-clinical-complexity-2',
    support_care_team_2: 'support-care-team-2',
    minimal_intake_context: 'minimal-intake-context',
    minimal_functional_needs: 'minimal-functional-needs',
    minimal_safety_clinical_complexity: 'minimal-safety-clinical-complexity',
    minimal_support_care_team: 'minimal-support-care-team',
  }
};

export const FORMAT_DATE_TIME = 'MM/DD/YYYY HH:mm A';

export const FORMAT_TIME = 'HH:mm A';

export const FORMAT_DATE = 'MM/DD/YYYY';

export const TIME_REGEX = /^\d{2}:\d{2} (AM|PM)/g;

export const DATE_TIME_REGEX = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2} (AM|PM)/g;
export const INCHES_FEETS_REGEEX = /^(([0-9]+)'?)(([0-9]+)"?)?$/g;

export const DATE_TIME_REGEX_TIME_ZONE = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2} (AM|PM) [A-Z]{2,2}$/g;

export const COMMONAPP = "MyHomeCareQuote";
export const COMMONAPP_VA = "MyHomeCareQuoteVA";
export const COMMONAPPS = [COMMONAPP, COMMONAPP_VA];
export const AppTesting = 'hcqdemo'
export const DATA_QUESTION_MOVING_NEXT_COMMONAPP: Record<string, any> = {
  contactTimeDate: 'additionalNotes',
  readyToScheduleHomeAppt: [
    {
      nextKey: 'contactTimeDate',
      condition: {
        readyToScheduleHomeAppt: '1',
      },
    },
    {
      nextKey: 'additionalNotes',
      condition: {
        readyToScheduleHomeAppt: '2',
      },
    },
  ],
  readyToScheduleHomeApptOther: [{
    nextKey: 'additionalNotes',
    condition: {
      readyToScheduleHomeAppt: '2',
    },
  }],
  currentlyInHospitalOrRehab: [
    {
      nextKey: "serviceStartDate",
      condition: {
        currentlyInHospitalOrRehab: '1',
      },
    },
    {
      nextKey: "source",
      condition: {
        currentlyInHospitalOrRehab: '2',
      },
    },
  ],
  whosInquiringFor: 'propertyType',
  paymentCategory: [
    {
      nextKey: 'propertyType',
      condition: {
        patientCallingFor: '2',
      },
    },
    {
      nextKey: 'propertyType',
      condition: {
        isStaff: '3',
      },
    },
  ],
  isStaff: [
    {
      nextKey: 'recipientName',
      condition: {
        isStaff: '2',
      },
    },
    {
      nextKey: 'fillerName',
      condition: {
        isStaff: '3',
      },
    },
  ],
  patientCallingFor: [
    {
      nextKey: 'recipientName',
      condition: {
        patientCallingFor: '1',
      },
    },
    {
      nextKey: 'callerName',
      condition: {
        patientCallingFor: '2',
      },
    },
  ],
  recipientEmail: 'currentlyInHospitalOrRehab',
  serviceStartDate: 'source',
  toileting: [{
    nextKey: 'incontinent',
    condition: {
      toileting: '4',
    },
  },
  {
    nextKey: 'bathing',
    condition: {

    },
  },

  ],
  toiletingOther: "bathing",
  toiletingUncertain: "bathing",
  relationshipOther: 'recipientName',
  relationshipOtherKey: 'recipientName',
  relationship: 'recipientName',
  relationshipOtherKeyOther: 'recipientName',
  transfers: [
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '3',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '4',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '5',
      },
    },
    {
      nextKey: 'toileting',
      condition: {

      },
    },
  ],
  transfersOther: [
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '3',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '4',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '5',
      },
    },
    {
      nextKey: 'toileting',
      condition: {

      },
    },
  ],
  transfersUncertain: [
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '3',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '4',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '5',
      },
    },
    {
      nextKey: 'toileting',
      condition: {

      },
    },
  ],
  recipientWeight: [
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '3',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '4',
      },
    },
    {
      nextKey: 'transferAssist',
      condition: {
        transfers: '5',
      },
    },
    {
      nextKey: 'toileting',
      condition: {

      },
    },
  ],
};
export const DATA_QUESTION_MOVING_PREV_COMMONAPP: Record<string, any> = {
  '1st_recipient': {
    contactTimeDate: 'servicesProvided',
    additionalNotes: 'readyToScheduleHomeAppt',
    readyToScheduleHomeAppt: 'servicesProvided',
    recipientName: [
      {
        backKey: 'isStaff',
        condition: {
          isStaff: '3',
        },
      }, // or
      {
        backKey: 'languagePreference',
        condition: {
          isStaff: '2',
        },
      }
    ],
    propertyType: [
      {
        backKey: 'paymentCategory',
        condition: {
          patientCallingFor: '2',
        },
      }, // or
      {
        backKey: 'paymentCategory',
        condition: {
          isStaff: '3',
        },
      },
    ],
    reassessmentQuote: 'languagePreference',
    currentlyInHospitalOrRehab: [
      {
        backKey: 'isStaff',
        condition: {
          isStaff: '2',
        },
      }
    ],
    source: 'currentlyInHospitalOrRehab',
    bathing: "toileting",
    serviceStartDate: 'isStaff',
    incontinent: "transfers",
    toileting: "transfers",
    fillerName: "languagePreference",
    transferAssist: "assistiveDevices",
  },
  full_care_2nd_recipient: {
    contactTimeDate: 'servicesProvided',
    anyAdditionalInfo: 'servicesProvided',
    readyToScheduleHomeAppt: 'servicesProvided',
    bathing: "toileting",
    incontinent: "transfers",
    toileting: "transfers",
    transferAssist: "assistiveDevices",


  },
};

export const DATA_QUESTION_REMOVE_COMMONAPP: Record<string, any> = {
  isStaff: {
    '2': [
      'fillerName',
      'fillerPhoneNumber',
      'fillerEmail',
      'relationship',
    ],
  },

  currentlyInHospitalOrRehab: {
    '2': ['serviceStartDate'],
  },
  readyToScheduleHomeAppt: {
    '2': ['contactTimeDate'],
  },
  toileting: {
    "1": ["incontinent"],
    "2": ["incontinent"],
    "3": ["incontinent"],
    "5": ["incontinent"],
    "@UN": ["incontinent"],
    "OT": ["incontinent"]
  },
  transfers: {
    "1": ["transferAssist"],
    "2": ["transferAssist"],
    "@UN": ["transferAssist"],
    "OT": ["transferAssist"]
  },
  anyAdditionalPerson:{
    "2":["donationPreference"],
    "3":["donationPreference"],
  }
};
const { anyAdditionalPerson, ...restRemoveCommonApp } = DATA_QUESTION_REMOVE_COMMONAPP;
export const DATA_QUESTION_REMOVE_COMMONAPP_VA: Record<string, any> = { ...restRemoveCommonApp };
export const DATA_QUESTION_LAST_COMMONAPP: Record<string, any> = {
  'inquiry-intake': ['generalConcernsAll'],
  'needs-required': ['nutrition'],
  'safety': ['contactTimeDatedate', 'contactTimeDatetime', 'anyAdditionalInfo', 'contactTimeDate'],
  'additional-notes': ['donationPreference'],
  'minimal-potential-client-intake': ['servicesProvided'],
  'potential-client-intake': [
    "generalConcernsAll"
  ],
  'needs-required-2': ['nutrition'],
  'safety-2': ['contactTimeDatedate', 'contactTimeDatetime', 'anyAdditionalInfo', 'contactTimeDate'],
  'additional-notes-2': ['donationPreference']
};

export const DATA_QUESTION_LAST_COMMONAPP_VA: Record<string, any> = {
  ...DATA_QUESTION_LAST_COMMONAPP,
  'additional-notes': ['anyAdditionalPerson'],
  'additional-notes-2': ['additionalNotes']
};
export const US_STATES = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FM: "Federated States Of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MH: "Marshall Islands",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  MP: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PW: "Palau",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};
export const TIMEZONE = {
  ET: "ET", EST: "ET", EDT: "ET",
  CT: "CT", CST: "CT", CDT: "CT",
  MT: "MT", MST: "MT", MDT: "MT",
  PT: "PT", PST: "PT", PDT: "PT"
};
export const DATA_BACK_ON_QUESTION_KEY = {
  'fillerName': "isStaff",
  'fillerPhoneNumber': "isStaff",
  'fillerEmail': "isStaff",
  'relationship': [
    {
      "key": "isStaff",
      "condition": {
        "isStaff": 3
      }
    },
    {
      "key": 'patientCallingFor',
      condition: {
        patientCallingFor: '2',
      },
    },
  ],
  'decisionMaker': [
    {
      "key": "isStaff",
      "condition": {
        "isStaff": 3
      }
    },
    {
      "key": 'patientCallingFor',
      condition: {
        patientCallingFor: '2',
      },
    },
  ],
  'staffMemberName': 'isStaff',
  'recipientName': [{
    "key": "isStaff",
    "condition": {
      "isStaff": 2
    }
  },
  {
    "key": 'patientCallingFor',
    condition: {
      patientCallingFor: '1',
    },
  }
  ],
  'recipientPhoneNumber': [
    {
      "key": "isStaff",
      "condition": {
        "isStaff": 2
      }
    },

    {
      "key": 'patientCallingFor',
      condition: {
        patientCallingFor: '1',
      },
    }
  ],
  'recipientGender':
    [{
      "key": "isStaff",
      "condition": {
        "isStaff": 2
      }
    },
    {
      "key": 'patientCallingFor',
      condition: {
        patientCallingFor: '1',
      },
    }
    ],
  'recipientDob': [
    {
      "key": "isStaff",
      "condition": {
        "isStaff": 2
      }
    },

    {
      "key": 'patientCallingFor',
      condition: {
        patientCallingFor: '1',
      },
    }],
  'recipientEmail': [{
    "key": "isStaff",
    "condition": {
      "isStaff": 2
    },

  },

  {
    "key": 'patientCallingFor',
    condition: {
      patientCallingFor: '1',
    },
  }],
  "callerName": "patientCallingFor",
  "callerPhoneNumber": "patientCallingFor",
  "callerEmail": "patientCallingFor",
  'transferAssist': "transfers",
  'contactTimeDate': "readyToScheduleHomeAppt",
  'anyAdditionalInfo': "readyToScheduleHomeAppt",
  "dischargeDate": "currentlyInHospitalOrRehab",
  "hospitalName": "currentlyInHospitalOrRehab",
  'incontinent': "toileting",
};
export const DATA_BACK_ON_QUESTION_KEY_COMMONAPP = {
  'fillerName': "isStaff",
  'fillerPhoneNumber': "isStaff",
  'fillerEmail': "isStaff",
  'relationship': "isStaff",
  'decisionMaker': 'isStaff',
  'recipientName': [{
    "key": "isStaff",
    "condition": {
      "isStaff": 2
    }
  }],
  'recipientPhoneNumber': [{
    "key": "isStaff",
    "condition": {
      "isStaff": 2
    }
  }],
  'recipientGender': [{
    "key": "isStaff",
    "condition": {
      "isStaff": 2
    }
  }],
  'recipientDob': [{
    "key": "isStaff",
    "condition": {
      "isStaff": 2
    }
  }],
  'recipientEmail': [{
    "key": "isStaff",
    "condition": {
      "isStaff": 2
    }
  }],
  'serviceStartDate': "currentlyInHospitalOrRehab",
  'transferAssist': "transfers",
  'incontinent': "toileting",
  'contactTimeDate': "readyToScheduleHomeAppt",

}
export const COMMON_QUESTION_LIST = [
    "languagePreference",
    "isStaff",
    "staffMemberName",
    "recipientName",
    "fillerName",
    "referralName",
    "reassessmentQuote",
    "patientCallingFor",
    "callerName"
];
export const QUESTION_KEY_HAS_OTHER_INPUT = [
  "paymentCategory",
  "companionSitterAll",
  "ambulation",
  "assistiveDevices",
  "transfers",
  "bathing",
  "toileting",
  "incontinent",
  // "dressing-grooming",
  "eating",
  "meals",
  "nutrition",
  "companion",
  "housekeeping",
  "petCare",
  "transportation",
  "falls",
  "erVisits",
  // "smoking",
  "oxygen_in_home",
  "medications",
  "currentFamilySupportLevel",
  "hospitalAdmissions",
];